import { Injectable } from '@angular/core';
import { environment } from '@env';

@Injectable({ providedIn: 'root' })
export class DiscountHelperService {
  constructor() {}
  calculateDiscountPercentage(actualPrice: number, unitPrice: number) {
    let discountPrice = actualPrice - unitPrice;
    let discountPercentage = (discountPrice / actualPrice) * 100;
    return Math.round(discountPercentage);
  }

  discountValueRounding(discount: number) {
    return (
      Math.round(discount / environment.discountRouding) *
      environment.discountRouding
    );
  }
}
